/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export const storeProducts = [
  {
    id: 1,
    title: "Tremocos Lupini Beans",
    img: "img/item1.jpg",
    price: 6.99,
    company: "Tradicao",
    info:
    "Lupini beans, tremocos, imported from Portugal.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Wine Gums",
    img: "img/item2.jpg",
    price: 5.99,
    company: "Norfolk Manor",
    info:
      "Gummy candies wine gums imported from the U.K. ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Local Honey",
    img: "img/item3.jpg",
    price: 18.99,
    company: "Cervenka Apiaries",
    info:
        "Local Honey made in the Cervenka Apiaries in Half Moon Bay, California.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Local Honey",
    img: "img/item4.jpg",
    price: 18.99,
    company: "Synders",
    info:
      "Local honey made in San Mateo County, California.", 
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "Marianne's Ice Cream",
    img:"img/item14.jpg",
    price: 7.99,
    company: "Mariannes",
    info:
      "Local ice cream made by the famous creamery, Mariannes, in Santa Cruz, California. ", 
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Purisssima Vodka",
    img: "img/item9.jpg",
    price: 31.99,
    company: "Purissima Distillery",
    info:
    "Local smalll batch handcrafted vodka made in Half Moon Bay, California. ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Cunha's Chardonnay",
    img: "img/item10.jpg",
    price: 9.99,
    company: "Cunha's Country Store",
    info:
      "Local chardonnay crafted for Cunha's Country Store.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Natural Olalliebery Jam",
    img: "img/item28.jpg",
    price: 9.99,
    company: "Arcangeli Grocery Co.",
    info:
      "Handcrafted natural olallieberry blend jam made in Pescadero, California by Arcangeli Grocery Co.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel - Black",
  img: "img/product-1.png",
  price: 10,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};
